import { createContext, useReducer } from "react";

export const Store = createContext();

const initialState = {
  userInfo: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null, // empty user default
  cart: {
    cartItems: localStorage.getItem("cartItems")
      ? JSON.parse(localStorage.getItem("cartItems"))
      : [], // empty cart default
  },
  wish: {
    wishItems: localStorage.getItem("wishItems")
      ? JSON.parse(localStorage.getItem("wishItems"))
      : [], // empty cart default
  },
};

function reducer(state, action) {
  switch (action.type) {
    case "CART_ADD_ITEM":
      //Add to cart

      const newItem = action.payload;
      const existItem = state.cart.cartItems.find(
        (item) => item._id === newItem._id
      );
      const cartItems = existItem
        ? state.cart.cartItems.map((item) =>
            item._id === existItem._id ? newItem : item
          )
        : [...state.cart.cartItems, newItem];
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
      return {
        ...state,
        cart: { ...state.cart, cartItems },
      };

    case "WISH_ADD_ITEM": {
      const newItem = action.payload;
      const existItem = state.cart.cartItems.find(
        (item) => item._id === newItem._id
      );
      const wishItems = existItem
        ? state.wish.wishItems.map((item) =>
            item._id === existItem._id ? newItem : item
          )
        : [...state.wish.wishItems, newItem];
      localStorage.setItem("wishItems", JSON.stringify(wishItems));
      return {
        ...state,
        wish: {
          ...state.wish,
          wishItems: [...state.wish.wishItems, action.payload],
        },
      };
    }

    case "CART_REMOVE_ITEM": {
      const cartItems = state.cart.cartItems.filter(
        (item) => item._id !== action.payload._id
      );
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
      return { ...state, cart: { ...state.cart, cartItems } };
    }

    case "CART_CLEAR":
      return { ...state, cart: { ...state.cart, cartItems: [] } };

    case "WISH_REMOVE_ITEM": {
      const wishItems = state.wish.wishItems.filter(
        (item) => item._id !== action.payload._id
      );
      localStorage.setItem("wishItems", JSON.stringify(wishItems));
      return { ...state, wish: { ...state.wish, wishItems } };
    }
    default:
      return state;
  }
}

export function StoreProvidor(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };

  return <Store.Provider value={value}>{props.children}</Store.Provider>;
}
